// src/pages/GTM/utils/gtmAdapter.js

function cleanText(text){

if(!text) return "";

return String(text)

.replace(/\r/g,"")

.replace(/\*\*/g,"")

.replace(/•/g,"\n")

.trim();

}


const sectionMap={

"STRATEGY":"strategy",

"ICP":"icp",

"POSITIONING":"positioning",

"ACQUISITION ENGINE":"execution",

"ACQUISITION CHANNELS":"execution",

"CHANNELS":"execution",

"GROWTH EXPERIMENTS":"experiments",

"EXECUTION ROADMAP":"roadmap",

"METRICS":"metrics",

"RISKS":"risks",

"CHECKLIST":"checklist",

"FOUNDER CHECKLIST":"checklist"

};


function parseItem(line){

if(!line) return null;


/* ignore section noise */

if(

line==="HIGH"||
line==="LOW"||
line==="MEDIUM"

){

return null;

}


const parts=

line.split("|")

.map(x=>x.trim())

.filter(Boolean);


return{

text:

parts[1]

? parts[0]+" : "+parts[1]

: parts[0],

priority:

parts[2] || "MEDIUM",

effort:

parts[3] || "MEDIUM",

impact:

parts[4] || "MEDIUM"

};

}


export function adaptGTMText(input){

if(!input){

return{

strategy:[],
icp:[],
positioning:[],
execution:[],
experiments:[],
roadmap:[],
metrics:[],
risks:[],
checklist:[]

};

}


let text=

typeof input==="string"

? input

: input?.gtmPlan ||

JSON.stringify(input);


const lines=

cleanText(text)

.split("\n")

.map(x=>x.trim())

.filter(Boolean);


const data={

strategy:[],
icp:[],
positioning:[],
execution:[],
experiments:[],
roadmap:[],
metrics:[],
risks:[],
checklist:[]

};


let current=null;


lines.forEach(line=>{

const upper=line.toUpperCase();


/* ⭐ STRONG SECTION DETECTION */

for(const key in sectionMap){

if(upper===key){

current=sectionMap[key];

return;

}

}


/* ignore header echoes */

if(

upper==="GROWTH EXPERIMENTS"||
upper==="EXECUTION ROADMAP"

){

return;

}


/* normal content */

if(current){

const parsed=parseItem(line);

if(parsed){

data[current].push(parsed);

}

}

});


return data;

}